import { render, staticRenderFns } from "./RsDashboard.vue?vue&type=template&id=85d85a94&scoped=true&"
import script from "./RsDashboard.vue?vue&type=script&lang=js&"
export * from "./RsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./RsDashboard.vue?vue&type=style&index=0&id=85d85a94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d85a94",
  null
  
)

export default component.exports